export default "__VITE_ASSET__872346cc__"